import { AssetApprovalActionModel, AssetApprovalModel } from '@casops/store/apis/assetApprovalsApi';
import { ReactElement, useMemo, useState } from 'react';
import AssetApprovalForm from '../form/AssetApprovalForm';
import ConflictResolutionDropdown from '../conflict-resolution-dropdown/ConflictResolutionDropdown';
import ConflictTable from '../conflict-table/ConflictTable';
import styles from './ConflictManager.module.scss';
import ConflictResolutionMessage from '../conflict-resolution-message/ConflictResolutionMessage';
import { useRenderKey } from '@casops/hooks/useRenderKey';

interface ConflictManagerProps {
  item: AssetApprovalModel;
}

export const ConflictManager = ({ item }: ConflictManagerProps): ReactElement => {
  const [selectedAction, setSelectedAction] = useState<number | null>(null);

  const action = useMemo<AssetApprovalActionModel | null>(() => {
    if (item.actions.length && selectedAction !== null) {
      return item.actions.find(({ id }) => id === selectedAction) ?? null;
    }

    return null;
  }, [item.actions, selectedAction]);

  // Reset the form if the action is changed because the fields need to load new values and the form state must be wiped.
  const renderKey = useRenderKey({ action });

  return (
    <>
      {item.conflicts && <ConflictTable conflicts={item.conflicts} />}

      {item.actions.length && (
        <div className={styles.dropdown}>
          <ConflictResolutionDropdown
            value={selectedAction}
            actions={item.actions}
            onChange={setSelectedAction}
          />
        </div>
      )}

      {action && (
        <AssetApprovalForm
          key={renderKey}
          id={item.id}
          approvalStatus={item.sts}
          action={action}
          helperMessage={<ConflictResolutionMessage item={item} action={action} />}
        />
      )}
    </>
  );
};

export default ConflictManager;
